var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "personRule" },
    [
      _c(
        "el-form",
        {
          ref: "personRule",
          staticClass: "form personRule",
          attrs: {
            model: _vm.form,
            "label-width": "180px",
            rules: _vm.personRules,
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("执法检查人员抽取规则")])]
            ),
            _vm.canEditpage
              ? _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "分组方式：",
                                  prop: "inspectorsGroupType",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.changeRadio },
                                    model: {
                                      value: _vm.form.inspectorsGroupType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "inspectorsGroupType",
                                          $$v
                                        )
                                      },
                                      expression: "form.inspectorsGroupType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "1" } }, [
                                      _vm._v("线下已分组"),
                                    ]),
                                    _c("el-radio", { attrs: { label: "2" } }, [
                                      _vm._v("系统随机分组"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.form.inspectorsGroupType == "2"
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-bottom": "0",
                                    },
                                    attrs: {
                                      label: "选择本次执法人员：",
                                      prop: "extractPondPersonList",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-plus",
                                          type: "primary",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showPersonDia()
                                          },
                                        },
                                      },
                                      [_vm._v("选择")]
                                    ),
                                    _vm.extractPondPersonList.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "selectPersonWrapper",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  margin: "10px 0 0",
                                                },
                                              },
                                              [
                                                _vm._v(" 共计 "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.extractPondPersonList
                                                        .length
                                                    )
                                                  ),
                                                ]),
                                                _vm._v("名 "),
                                              ]
                                            ),
                                            _c(
                                              "el-scrollbar",
                                              {
                                                style: {
                                                  "min-height": "30px",
                                                  "max-height": "440px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.extractPondPersonList,
                                                function (item, index) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: index,
                                                      staticStyle: {
                                                        margin: "10px",
                                                        color: "#1890ff",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name ||
                                                            item.personName +
                                                              (item.deptName ||
                                                              item.personDesc
                                                                ? "（" +
                                                                  (item.deptName
                                                                    ? item.deptName
                                                                    : item.personDesc) +
                                                                  "）"
                                                                : "")
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "执法检查人员分组：",
                                  prop: "groupNum",
                                },
                              },
                              [
                                _vm._v(" 执法检查人员共分为 "),
                                _c("el-input-number", {
                                  staticStyle: {
                                    width: "100px",
                                    "margin-right": "20px",
                                  },
                                  attrs: {
                                    "controls-position": "right",
                                    min: 0,
                                  },
                                  on: { change: _vm.changeGroupNum },
                                  model: {
                                    value: _vm.form.groupNum,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "groupNum", $$v)
                                    },
                                    expression: "form.groupNum",
                                  },
                                }),
                                _vm._v("个小组 "),
                                _vm.form.inspectorsGroupType == "2"
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.form.groupNum > 0
                                              ? false
                                              : true,
                                        },
                                        on: { click: _vm.saveAndRandom },
                                      },
                                      [_vm._v("开始随机分组")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-table",
                                  {
                                    ref: "tableDataRef",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.tableData,
                                      height: "250",
                                      border: "",
                                      "header-cell-style":
                                        this.$globalGrayTableHeaderStyle,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "分组",
                                        width: "150",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    "分组" +
                                                      _vm._s(scope.$index + 1)
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3713722795
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "name",
                                        label: "执法检查人员名称",
                                        align: "center",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "操作",
                                        width: "150",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm.form.inspectorsGroupType !=
                                                "2"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "text",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.showPersonDia(
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("选择执法人员")]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1815741105
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.canEditpage
              ? _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "分组方式：",
                                  prop: "extractPondPersonList",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form.inspectorsGroupType
                                        ? _vm.form.inspectorsGroupType == "1"
                                          ? "线下已分组"
                                          : "系统随机分组"
                                        : "---"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "本次执法人员：",
                                  prop: "extractPondPersonList",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form.extractPondPersonName || "---"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  label: "执法检查人员分组：",
                                  prop: "groupNum",
                                },
                              },
                              [
                                _vm._v(" 共分为 "),
                                _c("span", [_vm._v(_vm._s(_vm.form.groupNum))]),
                                _vm._v("个小组 "),
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.tableData,
                                      height: "250",
                                      border: "",
                                      "header-cell-style":
                                        this.$globalGrayTableHeaderStyle,
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "分组",
                                        width: "150",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    "分组" +
                                                      _vm._s(scope.$index + 1)
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3713722795
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "name",
                                        label: "执法检查人员名称",
                                        align: "center",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("personSelectDia", {
            ref: "personSelectDiaRef",
            attrs: {
              dialogVisible: _vm.extractPersonPondListDialog,
              isdisabled: true,
            },
            on: {
              "update:dialogVisible": function ($event) {
                _vm.extractPersonPondListDialog = $event
              },
              "update:dialog-visible": function ($event) {
                _vm.extractPersonPondListDialog = $event
              },
              dialogVisibles: _vm.cancelDialog,
              setSelectList: _vm.setSelectList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }